import { PaletteName } from '@payer-admin-ui/components-v2/src/layout/theme';

export const CREDIT_STATUS_COLORS = {
  APPROVED: 'success',
  REJECTED: 'danger',
  CONTROL: 'warning',
  DEFAULT: 'info',
} as const satisfies Record<string, PaletteName>;
